// Organization Type Options
export const ORGANIZATION_TYPES = ['supplier', 'customer', 'both', 'other'] as const
export type OrganizationType = (typeof ORGANIZATION_TYPES)[number]

// Organization Status Options
export const ORGANIZATION_STATUSES = [
  'active',
  'inactive',
  'target',
  'lead',
  'prospect',
  'former',
  'blacklisted',
  'archived',
] as const
export type OrganizationStatus = (typeof ORGANIZATION_STATUSES)[number]

// Organization Engagement Stages
export const ENGAGEMENT_STAGES = [
  'uncontacted',
  'contacted',
  'qualified',
  'active',
  'rejected',
  'former',
] as const
export type EngagementStage = (typeof ENGAGEMENT_STAGES)[number]

// Contact within an organization
export interface OrganizationContact {
  id: string
  personId: string
  role: string
  isPrimary: boolean
}

// Main Organization interface
export interface Organization {
  id?: string
  name: string

  // Classification
  type: OrganizationType
  status: OrganizationStatus
  engagementStage?: EngagementStage
  industry?: string
  size?: string

  // Contact information
  email?: string
  phone?: string
  fax?: string
  website?: string

  // Address
  address?: string
  streetAddress?: string
  city?: string
  state?: string
  zipCode?: string
  postalCode?: string
  country?: string

  // Fiscal information
  taxId?: string
  accountNumber?: string
  sales?: number
  assets?: number
  employees?: number

  // CRM fields
  contacts?: OrganizationContact[]
  notes?: string
  lastContactedAt?: Date
  nextFollowUpDate?: Date
  tags?: string[]
  assignedTo?: string
  source?: 'manual' | 'imported' | 'form' | 'referral'
  description?: string

  // Additional fields
  sicCodes?: string[]
  naicsCodes?: string[]
  locationType?: string
  twitterUrl?: string
  facebookUrl?: string
  linkedinUrl?: string
  isHomeBusiness?: boolean
  isFederalContractor?: boolean

  // Search fields
  name_lower?: string

  // Metadata
  createdAt: Date
  updatedAt: Date
  createdBy?: string
  updatedBy?: string
  isDeleted?: boolean
}

// UI helper options
export const organizationTypeOptions = ORGANIZATION_TYPES.map((type) => ({
  value: type,
  label: type.charAt(0).toUpperCase() + type.slice(1),
}))

export const organizationStatusOptions = ORGANIZATION_STATUSES.map((status) => ({
  value: status,
  label: status.charAt(0).toUpperCase() + status.slice(1),
}))

export const engagementStageOptions = ENGAGEMENT_STAGES.map((value) => ({
  value,
  label: value.charAt(0).toUpperCase() + value.slice(1),
}))
